import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
//---------------------------------------------------------------------
import Resize from "src/components/common/resize";
import LocatorForm from "src/components/outside/locator/locatorForm";
import LocatorEmergencyForm from "src/components/outside/locator/locatorEmergencyForm";
import OutsideBackupHistory from "src/components/outside/locator/outsideBackupHistory";
import UserInfo from "src/components/common/userInfo";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum, 
    weekDays, 
    getTimeStamp, 
    getDatefromWeekNum, 
    getDateEndFromWeekNum, 
    myAxios, 
    exclusiveOutisdeKeys, 
    statusColorCode, 
    MyFormData, 
    pmEmails, 
    MyDate, 
    locatorExceptionsList, 
    isDevMode, 
    calcLocate, 
    numberReducer, 
    locatorWeeks as weeks, 
    boolAndReducer,
    appTitle
} from "src/components/common/functions";
import DataReport from "./dataReport";
import PMReport from "./pmReport";
import Export from "./export";
import { customPrompt } from "src/components/common/customPrompt";
//--------------------------------------------------------------------------------------------
export default function OutsideStatus({ tabTitle }){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore((state) => state.setOutsideserviceLocatorDivisions);
    const forms = useMyStore((state) => state.outsideserviceLocatorForms);
    const setForms = useMyStore((state) => state.setOutsideserviceLocatorForms);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    //--------------------------------------------------------------------------------------------
    const [week, setWeek] = useState(() => !weeks.includes(path2)?weeknum((new MyDate()).s()):path2);
    //--------------------------------------------------------------------------------------------
    const curForms = useMemo(() => forms[week] ?? [], [forms, week]);
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt, 
        "Divisions": divisions.updatedAt === null?getTimeStamp():divisions.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [formEdit, setFormEdit] = useState({show: false});
    const [backupHistory, setBackupHistory] = useState([]);
    const [backupHistoryTarget, setBackupHistoryTarget] = useState(null);
    const [status, setStatus] = useState("");
    const [showHours, setShowHours] = useState(true);
    const [showMobHours, setShowMobHours] = useState(false);
    const [showTickets, setShowTickets] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(50);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredForms = useMemo(() => curForms.map(form => 
        ({...form, [week]: {
            ...form[week], 
            form: form[week].form.map((day, dayNum) => calcLocate(day, dayNum, getDatefromWeekNum(week, dayNum), form.outside, form.userName))
        }}))
        .filter(allForms => 
        !locatorExceptionsList.includes(allForms.email) &&
        !pmEmails.includes(allForms.email) && 
        (week?(
        week >= weeknum(allForms.hireDate) &&
        (allForms.quitDate?week <= weeknum(allForms.quitDate):true) &&
        ((status === "Submitted")?allForms[week]?.status === "Submitted":
        (status === "Created"?allForms[week]?.status !== "Submitted":true))
        ):true) && 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(allForms)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    ), [curForms, week, status, filterWords]);
    const currentForms = filteredForms.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredForms.length / itemsPerPage)}, (_, pageIndex) => (pageIndex + 1));
    const loadBackupHistory = async(renderedForm) => {
        const formData = new MyFormData();
        formData.append("wk", week);
        formData.append("userEmail", renderedForm.email);
        setShowLoader(true);
        const res = await myAxios("outside/locator/readBackups.php", formData);
        setShowLoader(false);
        if(!res) return;
        setBackupHistory(res.data);
        setBackupHistoryTarget({
            email: renderedForm.email,
            name: renderedForm.userName.replace(/ {2}/g, " "),
            status: renderedForm[week]?.status || "",
        });
    };
    const restoreBackup = async(backup) => {
        if(!backupHistoryTarget) return;
        if(!window.confirm(`Restore save from ${backup.time_created} for ${backupHistoryTarget.name}?\n\nThis will replace the current week, and the current version will be backed up first.`)) return;
        const formData = new MyFormData();
        formData.append("backupId", backup.id);
        formData.append("userEmail", backupHistoryTarget.email);
        setShowLoader(true);
        const res = await myAxios("outside/locator/restoreBackup.php", formData);
        setShowLoader(false);
        if(!res) return;
        setBackupHistory([]);
        setBackupHistoryTarget(null);
        const timeStamp = getTimeStamp();
        setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
    };
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(updateDateTime["Divisions"] === divisions.updatedAt) return;
        if(isDevMode) console.log("useEffect for side data");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            const formData = new MyFormData();
            //-------------------------------------------------
            setShowLoading(true);
            const resDivisions = await myAxios("outside/divisions/readDivisions.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resDivisions) return;
            //-------------------------------------------------
            setDivisions(resDivisions.data, updateDateTime["Divisions"]);
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [updateDateTime, divisions.updatedAt, setDivisions])
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect for main data");
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("week", week || weeknum((new MyDate()).s()));
            //-------------------------------------------------
            setShowLoading(true);
            const res = await myAxios("outside/locator/readTimeCards.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------------------------------
            const unordered = res.data.map(
                person => Object.fromEntries(Object.entries(person).map(
                    entries => !exclusiveOutisdeKeys.includes(entries[0])?
                    [entries[0], JSON.parse(entries[1] || 
                    JSON.stringify({
                        "form":Array(7).fill({
                            "data": [], 
                            "status": "Created", 
                            "overnight": false
                        })}))]
                    :
                    entries
            )));
            setForms(week, unordered, updateDateTime["Forms"]);
            history.replace(`/${path1}/${week}`);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[week, updateDateTime, forms, history, path1, setForms])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{backgroundColor: user.userTheme}}>
                <span>
                    <Resize/>
                    L&M Outside Status
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span> 
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select id = "week" className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setWeek(e.currentTarget.value);
                            setCurrentPage(1);
                            history.replace(`/${path1}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weeks.map((thisWeek, thisWeekIndex) => <option key = {thisWeekIndex} value = {thisWeek}>{getDateEndFromWeekNum(thisWeek)}</option>)}
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "status" className = "mb-0">Status:</label>
                    <select id = "status" className = "form-control w-auto ml-2" onChange = {e => {
                        setStatus(e.currentTarget.value);
                        setCurrentPage(1);               
                    }} value = {status}>
                        <option value = "">All</option>
                        <option>Submitted</option>
                        <option value = "Created">Unsubmitted</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "hours" className = "mb-0">
                        Hours:
                    </label>
                    <input
                        id = "hours"
                        className = "cssCheckBox ml-2"
                        type = "checkbox"
                        checked = {showHours}
                        onChange = {e => {
                            setShowHours(e.currentTarget.checked);                 
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "mob" className = "mb-0">
                        Mob:
                    </label>
                    <input
                        id = "mob"
                        className = "cssCheckBox ml-2"
                        type = "checkbox"
                        checked = {showMobHours}
                        onChange = {e => {
                            setShowMobHours(e.currentTarget.checked);                 
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "tickets" className = "mb-0">
                        Tickets:
                    </label>
                    <input
                        id = "tickets"
                        className = "cssCheckBox ml-2"
                        type = "checkbox"
                        checked = {showTickets}
                        onChange = {e => {
                            setShowTickets(e.currentTarget.checked);                 
                        }}
                    />
                </span>
                {filteredForms.length?
                <>
                <PMReport
                    filteredForms = {filteredForms}
                    week = {week}
                />
                <DataReport
                    filteredForms = {filteredForms}
                    week = {week}
                />
                </>:<></>}
                <Export/>
            </div>
            <div className = "cssContent pt-0 pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentForms.length?<div className = "cssLoading">Empty</div>:
                <div className = "overflow-visible">
                    <table className = "table text-center tableAllBorder">
                        <thead>
                            <tr className = "stickyHeader">
                                <th>
                                    Name
                                </th>
                                {weekDays.map((day, dayIndex) => 
                                <th key = {dayIndex}>
                                    {day} {getDatefromWeekNum(week, dayIndex)?"(" + getDatefromWeekNum(week, dayIndex) + ")":""}
                                </th>
                                )}
                                {week && (showHours || showMobHours || showTickets)?
                                <th>
                                    Summary
                                </th>
                                :<></>}
                            </tr>
                            </thead>
                            <tbody>
                                {currentForms.map((renderedForm, renderedFormIndex) => 
                                <tr id = {renderedForm.email} key = {renderedFormIndex} className = "pointer">
                                    <th>
                                        <div>
                                            <UserInfo 
                                                name = {renderedForm.userName.replace(/ {2}/g, " ")}
                                                email = {renderedForm.email}
                                            />
                                            {week?
                                            <span
                                                className = "badge badge-primary mx-2"
                                                onClick = {async () => {
                                                    if(!window.confirm(`Are you sure to withdraw ${renderedForm.userName.replace(/ {2}/g, " ")}"s timecards for the week?`)) return;
                                                    const formData = new MyFormData();
                                                    formData.append("userEmail", renderedForm.email);
                                                    formData.append("wk", week);
                                                    //-------------------------------------------------
                                                    setShowLoader(true);
                                                    const res = await myAxios("outside/locator/withdrawWeek.php", formData);
                                                    setShowLoader(false);
                                                    if(!res) return;
                                                    //-------------------------------------------------
                                                    setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?
                                                    {...allForms, 
                                                        [week]:{...allForms[week], status:""}
                                                    }:allForms));
                                                }}
                                            >
                                                {(renderedForm[week])?.status}
                                            </span>
                                            :<></>}
                                        </div>
                                        <div>{renderedForm.hireDate}</div>
                                        {renderedForm.quitDate?<div className = "text-danger">{renderedForm.quitDate}</div>:<></>}
                                        <div>
                                            <span
                                                className = "btn btn-primary p-1 my-1"
                                                onClick = {async () => {
                                                    const formData = new MyFormData();
                                                    formData.append("userEmail", renderedForm.email);
                                                    formData.append("wk", week);
                                                    //-------------------------------------------------
                                                    setShowLoader(true);
                                                    const res = await myAxios("outside/locator/emergency/add.php", formData);
                                                    setShowLoader(false);
                                                    if(!res) return;
                                                    //-------------------------------------------------
                                                    const thisWeekForm = renderedForm[week];
                                                    if(!thisWeekForm.emergency){
                                                        thisWeekForm.emergency = [];
                                                    }
                                                    thisWeekForm.emergency.push({data: [], status: "Created", overnight: false});
                                                    setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?
                                                    {...allForms, 
                                                        [week]: thisWeekForm
                                                    }:allForms));
                                                }}
                                            >
                                                Add EOT
                                            </span>
                                            <span
                                                className = "btn btn-primary p-1 ml-2 my-1"
                                                onClick = {async () => {
                                                    const validStr = ["1", "2", "3", "4", "5", "6", "7"];
                                                    const rules = "(1 for Monday, 2 for Tuesday... 7 for Sunday)";
                                                    const fromRule = `From Date\n:${rules}`;
                                                    const toRule = `To Date:\n${rules}`;
                                                    
                                                    let fromDate = await customPrompt(fromRule);
                                                    if(fromDate === null) return;
                                                    while(!validStr.includes(fromDate)){
                                                        window.alert("Input not valid.");
                                                        fromDate = await customPrompt(fromRule);
                                                        if(fromDate === null) return;
                                                    }
                                                    let toDate = await customPrompt(toRule);
                                                    if(toDate === null) return;
                                                    while(!validStr.includes(toDate)){
                                                        window.alert("Input not valid.");
                                                        toDate = await customPrompt(toRule);
                                                        if(toDate === null) return;
                                                    }
                                                    const fromIndex = window.Number.parseInt(fromDate) - 1;
                                                    const toIndex = window.Number.parseInt(toDate) - 1;
                                                    if(!window.confirm(`Are you sure to switch ${weekDays[fromIndex]} and ${weekDays[toIndex]} for ${renderedForm.userName.replace(/ {2}/g, " ")}?`)) return;
                                                    //-------------------------------------------------
                                                    const formData = new MyFormData();
                                                    formData.append("userEmail", renderedForm.email);
                                                    formData.append("wk", week);
                                                    formData.append("fromIndex", fromIndex);
                                                    formData.append("toIndex", toIndex);
                                                    //-------------------------------------------------
                                                    setShowLoader(true);
                                                    const res = await myAxios("outside/locator/switchDay.php", formData);
                                                    setShowLoader(false);
                                                    if(!res) return;
                                                    //-------------------------------------------------
                                                    const thisForm = renderedForm[week];
                                                    if(thisForm.status === "Submitted"){
                                                        thisForm.status = "Saved";
                                                    }
                                                    if(thisForm.form[fromIndex].status === "Submitted"){
                                                        thisForm.form[fromIndex].status = "Saved";
                                                    }
                                                    if(thisForm.form[toIndex].status === "Submitted"){
                                                        thisForm.form[toIndex].status = "Saved";
                                                    }
                                                    [thisForm.form[fromIndex], thisForm.form[toIndex]] = [thisForm.form[toIndex], thisForm.form[fromIndex]];
                                                    setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?{
                                                        ...allForms, 
                                                        [week]: thisForm
                                                    }:allForms));
                                                }}
                                            >
                                                Switch Day
                                            </span>
                                            <span
                                                className = "btn btn-primary p-1 ml-2 my-1"
                                                onClick = {async () => {
                                                const toRules = `To Week:\n(Example: w2022-01)\n(From Week is set to current week ${week})`;
                                                let toWeek = await customPrompt(toRules);
                                                if(toWeek === null) return;
                                                while(!weeks.filter(thisWeek => thisWeek !== week).includes(toWeek)){
                                                    window.alert("Input not valid.");
                                                    toWeek = await customPrompt(toRules);
                                                    if(toWeek === null) return;
                                                }
                                                if(!window.confirm(`Are you sure to switch ${week} and ${toWeek} for ${renderedForm.userName.replace(/ {2}/g, " ")}?`)) return;
                                                //-------------------------------------------------
                                                const formData = new MyFormData();
                                                formData.append("userEmail", renderedForm.email);
                                                formData.append("fromWk", week);
                                                formData.append("toWk", toWeek);
                                                //-------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("outside/locator/switchWeek.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //-------------------------------------------------
                                                
                                                //-------------------------------------------------
                                                setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?{
                                                    ...allForms, 
                                                    [week]: res.data
                                                }:allForms));
                                                }}
                                            >
                                                Switch Week
                                            </span>
                                            <span
                                                className = "btn btn-secondary p-1 ml-2 my-1"
                                                onClick = {() => loadBackupHistory(renderedForm)}
                                            >
                                                View Save History
                                            </span>
                                        </div>
                                        {week && renderedForm[week]?.emergency && renderedForm[week]?.emergency.length?
                                        renderedForm[week].emergency.map((e, i) => ({...e, i:i})).filter(e => !e.date).map((ee, i) => 
                                        <li key = {i} className = "my-1">
                                            <span
                                                className = "mr-2"
                                                style = {{color: statusColorCode(ee.status, "Work")}}
                                                onContextMenu = {e => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setFormEdit({
                                                        userName: renderedForm.userName.replace(/ {2}/g, " "), 
                                                        email: renderedForm.email, 
                                                        lanId: renderedForm.lanId,
                                                        day: ee.i,
                                                        show: "Emergency", 
                                                    });
                                                }}
                                            >
                                                EOT {ee.status}
                                            </span>
                                            <span
                                                className = "ml-1 btn btn-danger p-1"
                                                onClick = {async() => {
                                                    if(!window.confirm("Are you sure to delete this emergency call out?")) return;
                                                    const formData = new MyFormData();
                                                    formData.append("userEmail", renderedForm.email);
                                                    formData.append("wk", week);
                                                    formData.append("index", ee.i);
                                                    //-------------------------------------------------
                                                    setShowLoader(true);
                                                    const res = await myAxios("outside/locator/emergency/delete.php", formData);
                                                    setShowLoader(false);
                                                    if(!res) return;
                                                    //-------------------------------------------------
                                                    const thisWeekForm = renderedForm[week];
                                                    thisWeekForm.emergency = thisWeekForm.emergency.filter((_, index) => index !== i);
                                                    setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?
                                                        {...allForms, 
                                                            [week]: thisWeekForm
                                                        }:allForms)
                                                    );
                                                }}
                                            >
                                                Delete EOT
                                            </span>
                                        </li>)
                                        :<></>}
                                        {!renderedForm[week]?.form.map(day => day.status).some(status => status === "Created" || status === "Saved") 
                                        && renderedForm[week]?.status !== "Submitted"?
                                        <div>
                                            <span className = "btn btn-primary my-1" onClick = {async() => {
                                                if(!window.confirm("Are you sure to submit?")) return;
                                                const formData = new MyFormData();
                                                formData.append("userEmail", renderedForm.email);
                                                formData.append("wk", week);
                                                //-------------------------------------------------
                                                setShowLoader(true);
                                                const res = await myAxios("outside/locator/submitWeek.php", formData);
                                                setShowLoader(false);
                                                if(!res) return;
                                                //-------------------------------------------------
                                                setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?
                                                {...allForms, 
                                                    [week]:{...allForms[week], status:"Submitted"}
                                                }:allForms));
                                            }}>Submit</span>
                                        </div>
                                        :<></>}
                                    </th>
                                    {week?[0, 1, 2, 3, 4, 5, 6].map(i =>
                                    <th key = {i}>
                                        <div className = "mx-1 p-1" style = {{
                                            color:statusColorCode(
                                                renderedForm[week]?.form[i].status, 
                                                renderedForm[week]?.form[i].workStatus
                                            )
                                        }} 
                                        onClick = {() => {
                                            if(
                                                renderedForm[week]?.form[i].workStatus === "Work" &&
                                                renderedForm[week]?.form[i].status === "Submitted"
                                            ){
                                                window.open(`https://drive.google.com/file/d/${renderedForm[week].form[i].id}`)
                                            }
                                        }}
                                        onContextMenu = {e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setFormEdit({
                                                userName: renderedForm.userName.replace(/ {2}/g, " "), 
                                                email: renderedForm.email, 
                                                lanId: renderedForm.lanId,
                                                outside: renderedForm.outside, 
                                                day: i,
                                                show: "Normal", 
                                            });
                                        }}>
                                            {renderedForm[week]?.form[i].workStatus !== "Work" &&
                                            renderedForm[week]?.form[i].workStatus !== undefined &&
                                            renderedForm[week]?.form[i].status === "Submitted"?
                                            renderedForm[week]?.form[i].workStatus
                                            :
                                            renderedForm[week]?.form[i].status
                                            }
                                        </div>
                                        {renderedForm[week]?.form[i].workStatus === "Work" &&
                                        renderedForm[week]?.form[i].status === "Submitted" &&
                                        !renderedForm[week]?.form[i].data.find(item => item.category === "lunch")
                                        ?
                                        <div className = "text-info">
                                            no lunch
                                        </div>:<></>}
                                        {renderedForm[week]?.form[i].workStatus === "Work" &&
                                        renderedForm[week]?.form[i].status === "Submitted" && renderedForm[week]?.form[i].mobInTime > 90?
                                        <div className = "text-info">
                                            Mob In Time: {(renderedForm[week]?.form[i].mobInTime / 60).toFixed(2)}h
                                        </div>:<></>}
                                        {renderedForm[week]?.form[i].workStatus === "Work" &&
                                        renderedForm[week]?.form[i].status === "Submitted" && renderedForm[week]?.form[i].mobOutTime > 90?
                                        <div className = "text-info">
                                            Mob Out Time: {(renderedForm[week]?.form[i].mobOutTime / 60).toFixed(2)}h
                                        </div>:<></>}
                                        {renderedForm[week]?.form[i].workStatus === "Work" &&
                                        ["Off Work", "Sick", "Vacation"].includes(renderedForm[week]?.form[i].id)?
                                        <div className = "text-danger">
                                            Status Error
                                        </div>:<></>}
                                        {(renderedForm[week]?.form[i]?.id?.indexOf("Error") !== undefined && 
                                        renderedForm[week]?.form[i]?.id?.indexOf("Error") !== -1) || 
                                        (renderedForm[week]?.form[i].status === "Submitted" && 
                                        !renderedForm[week]?.form[i]?.id)?
                                        <div className = "text-primary ml-2">
                                            PDF Error
                                        </div>
                                        :<></>}
                                        {renderedForm[week]?.emergency?.length?
                                        renderedForm[week].emergency
                                        .map((e, i) => ({...e, i:i}))
                                        .filter(e => e.date === getDatefromWeekNum(week, i)).map((ee, i) => 
                                        <li key = {i}>
                                            <span
                                                className = "mr-2"
                                                style = {{
                                                    color: statusColorCode(ee.status, "Work")
                                                }}
                                                onClick = {() => {
                                                    ee.id && window.open(`https://drive.google.com/file/d/${ee.id}`)
                                                }}
                                                onContextMenu = {e => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setFormEdit({
                                                        userName: renderedForm.userName.replace(/ {2}/g, " "), 
                                                        email: renderedForm.email, 
                                                        lanId: renderedForm.lanId,
                                                        day: i,
                                                        show: "Emergency", 
                                                    });
                                                }}
                                            >
                                                EOT {ee.status}
                                            </span>
                                            <span
                                                className = "btn btn-danger p-1"
                                                onClick = {async() => {
                                                    if(!window.confirm("Are you sure to delete this emergency call out?")) return; 
                                                    const formData = new MyFormData();
                                                    formData.append("userEmail", renderedForm.email);
                                                    formData.append("wk", week);
                                                    formData.append("index", ee.i);
                                                    //-------------------------------------------------
                                                    setShowLoader(true);
                                                    const res = await myAxios("outside/locator/emergency/delete.php", formData);
                                                    setShowLoader(false);
                                                    if(!res) return;
                                                    //-------------------------------------------------
                                                    const thisWeekForm = renderedForm[week];
                                                    thisWeekForm.emergency = thisWeekForm.emergency.filter((_, index) => index !== i);
                                                    setForms(week, curForms.map(allForms => allForms.email === renderedForm.email?
                                                        {...allForms, 
                                                            [week]: thisWeekForm
                                                        }:allForms)
                                                    );
                                                }}
                                            >
                                                Delete EOT
                                            </span>
                                        </li>)
                                        :<></>}
                                        {showHours && renderedForm[week]?.form[i].regular?
                                        <div>Regular: {renderedForm[week]?.form[i].regular.toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form[i].mobReg?
                                        <div>Regular Mob: {renderedForm[week]?.form[i].mobReg.toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form[i].regular && renderedForm[week]?.form[i].mobReg?
                                        <div>Regular Mob Percentage: {(renderedForm[week]?.form[i].mobReg / renderedForm[week]?.form[i].regular * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showHours && renderedForm[week]?.form[i].ot?
                                        <div>OT: {renderedForm[week]?.form[i].ot.toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form[i].mobOT?
                                        <div>OT Mob: {renderedForm[week]?.form[i].mobOT.toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form[i].ot && renderedForm[week]?.form[i].mobOT?
                                        <div>OT Mob Percentage: {(renderedForm[week]?.form[i].mobOT / renderedForm[week]?.form[i].ot * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showTickets && renderedForm[week]?.form[i].status === "Submitted" && renderedForm[week]?.form[i].data?.length?
                                        <div># of tickets: {renderedForm[week]?.form[i].data?.length}</div>
                                        :<></>}
                                    </th>
                                    ):<></>}
                                    {week && (showHours || showMobHours || showTickets)?
                                    <th>
                                        {showHours && renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0)?
                                        <div>Regular: {renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0)?
                                        <div>Regular Mob: {renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0) && renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0)?
                                        <div>Regular Mob Percentage: {(renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0) / renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0) * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showHours && renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0)?
                                        <div>OT: {renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0)?
                                        <div>OT Mob: {renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0) && renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0)?
                                        <div>OT Mob Percentage: {(renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0) / renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0) * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showTickets && renderedForm[week]?.form.filter(day => day.status === "Submitted").map(day => day.data?.length ?? 0).reduce(numberReducer, 0)?
                                        <div># of tickets: {renderedForm[week]?.form.filter(day => day.status === "Submitted").map(day => day.data?.length ?? 0).reduce(numberReducer, 0)}</div>
                                        :<></>}
                                    </th>
                                    :<></>}
                                </tr>
                                )}
                                {week && (showHours || showMobHours || showTickets)?
                                <tr>
                                    <th className = "align-middle">Current Page Total</th>
                                    {[0, 1, 2, 3, 4, 5, 6].map(i =>
                                    <th key = {i}>
                                        {showHours && currentForms.map(renderedForm => renderedForm[week]?.form[i].regular ?? 0).reduce(numberReducer, 0)?
                                        <div>Regular: {currentForms.map(renderedForm => renderedForm[week]?.form[i].regular ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form[i].mobReg ?? 0).reduce(numberReducer, 0)?
                                        <div>Regular Mob: {currentForms.map(renderedForm => renderedForm[week]?.form[i].mobReg ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form[i].regular ?? 0).reduce(numberReducer, 0) && currentForms.map(renderedForm => renderedForm[week]?.form[i].mobReg ?? 0).reduce(numberReducer, 0)?
                                        <div>Regular Mob Percentage: {(currentForms.map(renderedForm => renderedForm[week]?.form[i].mobReg ?? 0).reduce(numberReducer, 0) / currentForms.map(renderedForm => renderedForm[week]?.form[i].regular ?? 0).reduce(numberReducer, 0) * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showHours && currentForms.map(renderedForm => renderedForm[week]?.form[i].ot ?? 0).reduce(numberReducer, 0)?
                                        <div>OT: {currentForms.map(renderedForm => renderedForm[week]?.form[i].ot ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form[i].mobOT ?? 0).reduce(numberReducer, 0)?
                                        <div>OT Mob: {currentForms.map(renderedForm => renderedForm[week]?.form[i].mobOT ?? 0).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form[i].ot ?? 0).reduce(numberReducer, 0) && currentForms.map(renderedForm => renderedForm[week]?.form[i].mobOT ?? 0).reduce(numberReducer, 0)?
                                        <div>OT Mob Percentage: {(currentForms.map(renderedForm => renderedForm[week]?.form[i].mobOT ?? 0).reduce(numberReducer, 0) / currentForms.map(renderedForm => renderedForm[week]?.form[i].ot ?? 0).reduce(numberReducer, 0) * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showTickets && currentForms.map(renderedForm => renderedForm[week]?.form[i].status === "Submitted"?renderedForm[week]?.form[i].data?.length??0:0).reduce(numberReducer, 0)?
                                        <div># of tickets: {currentForms.map(renderedForm => renderedForm[week]?.form[i].status === "Submitted"?renderedForm[week]?.form[i].data?.length??0:0).reduce(numberReducer, 0)}</div>
                                        :<></>}
                                    </th>)}
                                    <th>
                                        {showHours && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div>Regular: {currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div>Regular Mob: {currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0) && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div>Regular Mob Percentage: {(currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobReg ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2) / currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.regular ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0) * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showHours && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div>OT: {currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div>OT Mob: {currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2)}h</div>
                                        :<></>}
                                        {showMobHours && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0) && currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div>OT Mob Percentage: {(currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.mobOT ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0).toFixed(2) / currentForms.map(renderedForm => renderedForm[week]?.form.map(day => day.ot ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0) * 100).toFixed(2)}%</div>
                                        :<></>}
                                        {showTickets && currentForms.map(renderedForm => renderedForm[week]?.form.filter(day => day.status === "Submitted").map(day => day.data?.length ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)?
                                        <div># of tickets: {currentForms.map(renderedForm => renderedForm[week]?.form.filter(day => day.status === "Submitted").map(day => day.data?.length ?? 0).reduce(numberReducer, 0)).reduce(numberReducer, 0)}</div>
                                        :<></>}
                                    </th>
                                </tr>
                                :<></>}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredForms.length?
                <Footer
                    length = {filteredForms.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
            {formEdit.show === "Normal"?
            <LocatorForm
                userName = {formEdit.userName.replace(/ {2}/g, " ")}
                email = {formEdit.email}
                lanId = {formEdit.lanId}
                outside = {formEdit.outside}
                admin = {true}
                week = {week}
                dayIndex = {window.Number.parseInt(formEdit.day)}
                defaultData = {curForms.find(allForms => allForms.email === formEdit.email)?.[week]}
                closeIt = {() => {
                    setFormEdit({show: false});
                }}
            />
            :<></>}
            {formEdit.show === "Emergency"?
            <LocatorEmergencyForm
                userName = {formEdit.userName.replace(/ {2}/g, " ")}
                email = {formEdit.email}
                lanId = {formEdit.lanId}
                admin = {true}
                week = {week}
                dayIndex = {window.Number.parseInt(formEdit.day)}
                defaultData = {curForms.find(allForms => allForms.email === formEdit.email)?.[week]}
                closeIt = {() => {
                    setFormEdit({show: false});
                }}
            />:<></>}
            {backupHistoryTarget?
            <OutsideBackupHistory
                backups = {backupHistory}
                week = {week}
                targetName = {backupHistoryTarget.name}
                closeIt = {() => {
                    setBackupHistory([]);
                    setBackupHistoryTarget(null);
                }}
                restoreBackup = {restoreBackup}
                currentWeekStatus = {backupHistoryTarget.status}
            />
            :<></>}
        </div>
    )
}